import React from 'react';

import PropTypes from 'prop-types';

const UpdatedOn = (props) => {
    const { children } = props;
    return <span>Updated on {children}</span>;
};

UpdatedOn.propTypes = {
    children: PropTypes.node,
};

export default UpdatedOn;
